module.exports = __webpack_public_path__ + "static/staff_of_the_adder-c6502edd90cba777f7bbe401543af41c.jpeg";